// extracted by mini-css-extract-plugin
export default {"imageWrapper":"FK-z","twoColumnImage":"GK-z"};